import { Box, Slider, Theme, ThemeProvider } from "@mui/material";
import IconFilterRoom from "assets/icons/filter/ic_filter_room.svg";
import { roomsMarks } from "common/consts/estates";
import React, { useCallback, useMemo } from "react";
import { SliderCaption } from "./SliderCaption";
import { useSliderHooks } from "./hooks";

const thumbClassName = "rooms-thumb";

export const RoomsSlider = React.memo(
  (props: {
    sliderTheme: Theme;
    id: string;
    styles: Record<string, string>;
    valueFrom: number;
    valueTo: number;
    formattedRoomsFrom: string;
    formattedRoomsTo: string;
    onChange: (
      event: Event,
      value: number | number[],
      activeThumb: number
    ) => void;
  }) => {
    const hooks = useSliderHooks({ onChange: props.onChange }, thumbClassName);

    const { sliderRef } = hooks;

    const marks = useMemo(
      () =>
        roomsMarks.map((x, index) => ({
          value: index,
          label: x.displayAlways ? Number(x.label).toLocaleString() : ""
        })),
      []
    );

    const valueText = useCallback((value: number) => {
      return value === 0
        ? "下限なし"
        : value === roomsMarks.length - 1
        ? "上限なし"
        : `${roomsMarks[value].value} 部屋`;
    }, []);

    const valueLabelFormat = useCallback(
      (value: number) => {
        return valueText(value);
      },
      [valueText]
    );

    return (
      <ThemeProvider theme={props.sliderTheme}>
        <Box className={props.styles.box}>
          <Box className={props.styles.ic_tit}>
            <img src={IconFilterRoom} alt="部屋" />
          </Box>
          <Box className={props.styles.setting}>
            <SliderCaption
              captionRef={hooks.captionRef}
              arrowRef={hooks.arrowRef}
              styles={props.styles}
              captionLeft={hooks.captionLeft}
              captionRight={hooks.captionRight}
              arrowLeft={hooks.arrowLeft}
              arrowRight={hooks.arrowRight}
              title="間取り"
              fromCaption={[props.formattedRoomsFrom, "部屋"]}
              toCaption={[props.formattedRoomsTo, "部屋"]}
              chaseThumb={hooks.chaseThumb}
            />
            <Slider
              ref={sliderRef}
              value={[props.valueFrom, props.valueTo]}
              onChange={hooks.onChange}
              valueLabelFormat={valueLabelFormat}
              aria-labelledby={props.id}
              getAriaValueText={valueText}
              valueLabelDisplay="off"
              marks={marks}
              min={0}
              max={roomsMarks.length - 1}
              step={null}
              slotProps={{
                thumb: {
                  className: thumbClassName
                }
              }}
            />
          </Box>
        </Box>
      </ThemeProvider>
    );
  }
);
